<main>
  <app-hamburger [ngClass]="routeClass"></app-hamburger>
  <section *ngIf="!isAuthing(); else appLoaded" [ngClass]="routeClass">
    {{ pageTitle }}
    <article (click)="closeBurger()" >
      <app-header></app-header>
      <app-alert-banner #alertbanner></app-alert-banner>
      <router-outlet></router-outlet>
    </article>
  </section>
  <ng-template #appLoaded>
    <app-loading></app-loading>
  </ng-template>
  <span id="version-number" [ngClass]="{'expand-version' : expandVersion}" [matTooltip]="'Double click to copy - ' + version" (dblclick)="copyToClipboard(version)" matTooltipShowDelay="500">{{version}}</span>
</main>

